var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 1.25C8.15365 1.25 4.84209 3.96483 4.08777 7.7364L2.83398 14.0054C2.43126 16.019 3.50016 18.0431 5.36748 18.873C6.0493 19.176 6.74912 19.4298 7.46108 19.6343L7.56484 19.8678C8.34382 21.6205 10.0819 22.75 11.9999 22.75C13.9179 22.75 15.656 21.6205 16.435 19.8678L16.5387 19.6343C17.2507 19.4298 17.9505 19.176 18.6323 18.873C20.4996 18.0431 21.5686 16.019 21.1658 14.0054L19.912 7.7364C19.1577 3.96483 15.8462 1.25 11.9999 1.25ZM15.8892 18.2581C15.8352 18.2662 15.7823 18.2802 15.7315 18.2997C13.291 18.9283 10.7088 18.9283 8.26833 18.2997C8.21754 18.2802 8.16464 18.2662 8.1106 18.2581C7.38357 18.0623 6.66975 17.8103 5.97668 17.5023C4.7415 16.9533 4.04174 15.6151 4.30485 14.2995L5.55864 8.03057C6.17273 4.96014 8.86867 2.75 11.9999 2.75C15.1311 2.75 17.8271 4.96014 18.4412 8.03057L19.695 14.2995C19.9581 15.6151 19.2583 16.9533 18.0231 17.5023C17.3301 17.8103 16.6162 18.0623 15.8892 18.2581ZM9.44866 20.0731C11.1374 20.3372 12.8624 20.3372 14.5511 20.0731C13.9241 20.808 12.9972 21.25 11.9999 21.25C11.0026 21.25 10.0757 20.808 9.44866 20.0731Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.79b15e11bbdddf70e53d8219e752ac92.svg";
export { ForwardRef as ReactComponent };